import {
  InputField,
  PasswordField,
  RadioField,
  SubmitButton,
} from "components/form";
import { ApiUsersProduct } from "utils/api/users";

const Form = ({ isSignup }) => {
  return (
    <>
      <InputField name="email" type="email" label="Email" />
      <PasswordField
        name="password"
        label="Password"
        autoComplete={isSignup ? "new-password" : undefined}
      />
      {isSignup && (
        <RadioField
          name="product"
          label="Product"
          options={[
            { label: "EWA Flex", value: ApiUsersProduct.ewaFlex },
            { label: "EWA Direct", value: ApiUsersProduct.ewaDirect },
          ]}
        />
      )}
      <SubmitButton>Submit</SubmitButton>
    </>
  );
};

export default Form;
